import * as React from 'react';
import DatePicker from '../../DatePicker/DatePicker';
import { connect } from 'react-redux';
import { SecondaryAdminJudgementQuestion } from '../../../interfaces/Legal/legalInterfaces';
import KPDropdown from '../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import { setLegalAnswerById, checkLegalQuestionValidation } from '../../../actions/salesActions';
import { Form } from 'react-bootstrap';

class SecondaryLegalSection extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedValue: '',
            searchItems: [],
            cursor: 0,
            selectedObject: undefined,
        }
        this.handleSelectedItemDropdown = this.handleSelectedItemDropdown.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
    }

    async handleSelectedItemDropdown(e: any) {
        await this.setState({
            selectedValue: e
        })
        await this.props.dispatchSetLegalAnswerById(this.props.question.id, undefined, Number(e));
        await this.props.dispatchCheckLegalQuestionValidation();
    }

    async autocomplete(evt) {
        let text = evt.target.value;
        var listmax = 50;   //Make the search quicker - can't return full list
        var items;
        await this.setState({ selectedValue: text });
        await this.setState({ searchItems: [] });
        let questionItem: SecondaryAdminJudgementQuestion = this.props.question as SecondaryAdminJudgementQuestion;

        if (text && text.length >= 1) {
            items = questionItem.adminJudgementQuestionReasons.filter(x => x.description.toLowerCase().startsWith(text.toLowerCase()) && !x.description.toLowerCase().includes('other'))
                .filter((i, index) => (index < listmax))
                .map((i) => {
                    return (
                        i
                    );
                });
            items.push(questionItem.adminJudgementQuestionReasons.find(x => x.description.toLowerCase().includes('other')));
            await this.setState({ searchItems: items });
        }
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === 27) {
            this.setState({ searchItems: [] });
            return false;
        }
    }

    hanldeKeydown(evt) {
        // arrow up/down button should select next/previous list element
        if (evt.keyCode === 38 && this.state.cursor > 0) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (evt.keyCode === 40 && this.state.cursor < this.state.searchItems.length - 1) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        }
        if (evt.keyCode === 13) {
            let currentItem = this.state.searchItems[this.state.cursor];
            if (currentItem !== undefined) {
                this.setState({ searchItems: [] });
            }
        }
    }

    async selectItem(item) {
        this.setState({ selectedValue: item.description, selectedObject: item });
        this.setState({ searchItems: [] });
        this.props.dispatchSetLegalAnswerById(this.props.question.id, undefined, Number(item.id));
        await this.props.dispatchCheckLegalQuestionValidation();
    }

    componentDidMount() { }

    public render() {
        let questionItem: SecondaryAdminJudgementQuestion = this.props.question as SecondaryAdminJudgementQuestion;
        let questionTextHeading = '';
        if (questionItem.secondaryQuestionType === 1 && questionItem.id !== "a1b49c22-a607-453a-88fe-07420c016fa4") {
            questionTextHeading = 'Reason'
        }
        else if (questionItem.secondaryQuestionType === 1 && questionItem.id === "a1b49c22-a607-453a-88fe-07420c016fa4") {
            questionTextHeading = 'Please select'
        }
        else if (questionItem.secondaryQuestionType !== 1) {
            questionTextHeading = 'Date'
        }
        let selectedItem = '';
        return (
            <div className="row noma mt-20px mobile-mt-30px">
                <div className="col-12 nopa">
                    <div className="row noma">
                        <div className="col-lg-8 col-12 mt-13px mobile-mt-0px mobile-mb-15px for-modal-mobile-use">
                            <p className={"line-height-normal font-weight-normal " + (this.state.selectedValue !== "" || this.props.sales.adminJudgementAnswerSet.secondaryAdminJudgementAnswers.find(x => x.secondaryQuestionId === questionItem.id).dateAnswerStr !== undefined || this.props.sales.adminJudgementAnswerSet.secondaryAdminJudgementAnswers.find(x => x.secondaryQuestionId === questionItem.id).dropdownAnswer > 0 ? "mobile-mt-0px mt-20px mb-0px" : "mt-0px mb-0px")}>{questionItem.text}</p>
                        </div>
                        <div className="col-lg-4 col-12 " id="Legal-seconday-q">
                            <Form.Label className={'font-size-14px font-weight-bold mb-6px' + (this.state.selectedValue !== "" || this.props.sales.adminJudgementAnswerSet.secondaryAdminJudgementAnswers.find(x => x.secondaryQuestionId === questionItem.id).dateAnswerStr !== undefined ? "" : " no-opacity d-none")}>{questionTextHeading}</Form.Label>
                            <div id="secondary-legal">
                                {questionItem.secondaryQuestionType === 1 && questionItem.id !== "06cfe6de-5332-4c2e-bd5a-57c66eb9ef22" &&
                                    <KPDropdown
                                        id={"Choose-Legal-Answer"}
                                        isImageDropdown={false}
                                        showLabelAfterSelection={false}
                                        showLabelInside={true}
                                        isRiskItem={false}
                                        labelAfterSelection={""}
                                        title={"Please select"}
                                        label={"Please select"}
                                        data={questionItem.adminJudgementQuestionReasons}
                                        handleSelection={(e) => this.handleSelectedItemDropdown(e)}
                                        selectedValue={questionItem.adminJudgementQuestionReasons.find(x => x.id === Number(this.state.selectedValue))?.description ?? undefined}
                                    />
                                }
                                {questionItem.secondaryQuestionType === 1 && questionItem.id === "06cfe6de-5332-4c2e-bd5a-57c66eb9ef22" &&
                                    <div>
                                        <input
                                            type="text"
                                            id="autocomplete"
                                            onChange={this.autocomplete}
                                            onKeyUp={this.hanldeKeyup}
                                            onKeyDown={this.hanldeKeydown}
                                            value={this.state.selectedValue}
                                            className="custom-input form-control auto-complete-search-icon"
                                            placeholder="Start typing..."
                                        />
                                        {this.state.searchItems.length > 0 && (
                                            <ul id="makeAndModel" className="list-group">
                                                {this.state.searchItems.map((item, idx) => (
                                                    <li
                                                        className={
                                                            this.state.cursor === idx ? "active list-group-item" : "list-group-item"
                                                        }
                                                        key={idx}
                                                        onClick={() => this.selectItem(item)}
                                                    >
                                                        {item.description}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                }
                                {questionItem.secondaryQuestionType !== 1 &&
                                    <DatePicker isSales={true} questionId={questionItem.id} />
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetLegalAnswerById: (questionId, answerDate, answerDropdown) => dispatch(setLegalAnswerById(questionId, answerDate, false, answerDropdown)),
        dispatchCheckLegalQuestionValidation: () => dispatch(checkLegalQuestionValidation()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryLegalSection);